/**
 * APP UTILS
 *
 * Utils related specifically to the app coponent. Note that this is not a 'generic' utils file. Utils should be organized into
 * files based on their function. See app/utils folder for examples and existing util groupings.
*/

export const SPORT_KEY_FOR_ROUTE = 'sport';
export const GAME_ID_KEY_FOR_ROUTE = 'gameId';
export const PERIOD_KEY_FOR_QUERY_PARAM = 'period';
